const HeaderSeparator = () => {
  return (
    <div
      style={{
        width: 1,
        height: '55%',
        backgroundColor: 'rgba(0,0,0,0.1)',
        alignSelf: 'center',
        margin: '0 0.8em',
        pointerEvents: 'none',
      }}
    />
  )
}

export default HeaderSeparator